module.exports = __webpack_public_path__ + "static/media/Blender-3.69078492.webp";